import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {Loner} from "../../../Loner";
import {LonerSound} from "../../../sound/LonerSound";

/**
 * Created by Jerker Nord on 2022-11-10.
 */

export class LonerShootShootDuckOutroPresentation implements SimplePresentation {

    private _shootingComplete: boolean = false;
    private _doOutro: boolean = false;
    private _controller: SimplePresentationRunnerController;

    shouldRun(): boolean {
        return Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK
            && Loner.model.data.nextMode == LonerGameMode.NORMAL
            && !Loner.model.data.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._doOutro = true;
        this.checkFinish();
    }

    private checkFinish(): void {
        if (this._shootingComplete == true && this._doOutro == true) {
            this._shootingComplete = false;
            this._doOutro = false;
            this.doOutroPresentation();
        }
    }

    private doOutroPresentation(): void {
        const mainTL: gsap.core.Timeline = gsap.timeline();
        const amount: number = Loner.model.accumulatedRoundWin;
        const countDuration: number = 1.871;

        mainTL.add(() => {
            Loner.ssdMainView.stopAllDucks()
        });
        mainTL.add(gsap.timeline({delay: 2.1}));
        mainTL.add(() => Loner.keypadPlugin.setZeroBetSpinCounter(-1));
        let aborted = false;

        const isWinBelowStake: boolean = Loner.isWinBelowStake();

        mainTL.add(Loner.ssdOutroView.showOutro(() => this.fsIntroClosedCallback(this._controller, isWinBelowStake)));
        mainTL.add(() => this._controller.setSkipCallback(() => {
            aborted = true;
            mainTL.seek("end", false);
        }));
        mainTL.add(Loner.ssdOutroView.getCountUp(amount, countDuration, isWinBelowStake));
        mainTL.add([Loner.ssdOutroView.showAssets(),
            () => {
                this._controller.setSkipCallback()
                Loner.soundPlayer.playSound(LonerSound.SSD_OUTRO_LOOP, 1, Number.MAX_VALUE);
            },
            Loner.ssdOutroView.showButton()
        ]);
        mainTL.addLabel("end");
    }

    private fsIntroClosedCallback(controller: SimplePresentationRunnerController, isWinBelowStake: boolean): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => {
            Loner.soundPlayer.stopSound(LonerSound.SSD_OUTRO_LOOP);
            Loner.soundPlayer.playSound(LonerSound.CONTINUE_BUTTON);
            if (!Loner.model.brokeBank) {
                Loner.soundPlayer.playSound(LonerSound.SSD_BACK_TO_MAIN);
            }
            Loner.soundPlayer.switchMusic(LonerGameMode.NORMAL);
            Loner.soundPlayer.fadeMusic(0, 0.4, 0);
            gsap.timeline({delay: 1}).add(() => {
                Loner.soundPlayer.fadeMusic(0.4, 1, 500);
            });
        });
        tl.add(Loner.ssdOutroView.hideOutro(isWinBelowStake));
    }

    set shootingComplete(value: boolean) {
        this._shootingComplete = value;
        this.checkFinish();
    }
}